import { Route } from "@angular/router";

import { LoginComponent } from "@local/app/pages/login";
import { LogoutComponent } from "@local/app/pages/logout";
import { VerifyMagicTokenComponent } from "@local/app/pages/magic-token/verify-magic-token.component";
import { MartsComponent } from "@local/app/pages/marts";
import { RequestResetPasswordComponent } from "@local/app/pages/request-reset-password";
import { ResetPasswordComponent } from "@local/app/pages/reset-password";
import { SetPasswordComponent } from "@local/app/pages/set-password";
import { UserSettingsComponent } from "@local/app/pages/user-settings";

import {
  RequireLoggedInGuard,
  RequireLoggedOutGuard,
  RequireMagicTokenParamGuard
} from "./guards";
import { UserInfoResolver } from "./resolvers";

export const routes: Route[] = [
  {
    path: "login",
    component: LoginComponent,
    canActivate: [RequireLoggedOutGuard]
  },
  {
    path: "verify-magic-token",
    component: VerifyMagicTokenComponent,
    canActivate: [RequireLoggedOutGuard, RequireMagicTokenParamGuard]
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent,
    canActivate: [RequireLoggedOutGuard]
  },
  {
    path: "set-password",
    component: SetPasswordComponent,
    canActivate: [RequireLoggedOutGuard]
  },
  {
    path: "forgot-password",
    component: RequestResetPasswordComponent,
    canActivate: [RequireLoggedOutGuard]
  },
  {
    path: "marts",
    component: MartsComponent,
    canActivate: [RequireLoggedInGuard]
  },
  {
    path: "user-settings",
    component: UserSettingsComponent,
    resolve: {
      user: UserInfoResolver
    },
    canActivate: [RequireLoggedInGuard]
  },
  {
    path: "logout",
    component: LogoutComponent
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "marts"
  },
  {
    path: "**",
    redirectTo: "/not-found"
  }
];
